/**
 * Projects Page - Migrated to use EntitiesList
 *
 * This page now uses the generic EntitiesList component with
 * Projects-specific configuration for a standardized experience.
 */

import React from "react";

// Generic EntitiesList component and entity configurations
import EntitiesList from "../components/entities/EntitiesList";
import ProjectsConfig from "../components/entities/projects/ProjectsConfig";
import ProjectsColumns from "../components/entities/projects/ProjectsColumns";
import * as ProjectsMetrics from "../components/entities/projects/ProjectsMetrics";

// Custom components specific to Projects
import ProjectTypeDropdown from "../components/ui/ProjectTypeDropdown";

// API hooks
import { useProjects } from "../hooks/useApi";

/**
 * Projects Page Component
 *
 * Uses the generic EntitiesList with Projects-specific configuration
 * to provide a consistent, standardized experience.
 */
function Projects() {
  // API hooks for projects data
  const {
    items: projects = [],
    loading,
    error,
    refresh: refetch,
    clearError,
  } = useProjects();

  // Custom Header Actions component for Projects
  const ProjectsHeaderActions = () => <ProjectTypeDropdown />;

  // Custom Empty State Actions for Projects
  const ProjectsEmptyStateActions = () => <ProjectTypeDropdown />;

  return (
    <EntitiesList
      // Entity configuration
      entityConfig={ProjectsConfig}
      entityColumns={ProjectsColumns}
      entityMetrics={ProjectsMetrics}
      // Data and state
      entities={projects}
      loading={loading}
      error={error}
      // API functions
      refreshFunction={refetch}
      clearErrorFunction={clearError}
      // Custom components
      HeaderActions={ProjectsHeaderActions}
      EmptyStateActions={ProjectsEmptyStateActions}
      // Layout preferences
      layout="table"
    />
  );
}

export default Projects;
